<template>
  <transition name="show-password">
    <button
      v-if="show"
      type="button"
      class="show-password"
      tabindex="-1"
      :class="classModifiers"
      @click.stop="onPasswordToggle"
      :title="title"
    >
      &nbsp;
    </button>
  </transition>
</template>

<script src="./show-password-icon.js"></script>
<style src="./show-password-icon.scss" lang="scss"></style>
